<template>
  <div class="pr-2">
    <v-row>
      <v-col class="name py-0"
             cols="10">
        {{ item.name }}
      </v-col>
      <v-col class="py-0 d-flex justify-end align-content-end"
             cols="2">
        <v-btn icon
               small
               @click="removeItem">
          <v-icon :color="$finColors.coolGrey">icon-delete
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="price mb-0 py-0" cols="7">
        <span class="mr-4">Kaufpreis</span>
        <span class="price-value" v-if="item.latestPrice">{{ item.latestPrice.price | finCurrency }}</span>
        <span class="price-value" v-else>-</span>
        <div class="stockinfo" v-if="item.latestPrice">
          <span>Börse {{ item.latestPrice.exchangeName }}; </span>
          {{ item.latestPrice.timestamp | dayAndHourAndYearShort }} Uhr
        </div>
      </v-col>
      <v-col class="d-flex justify-end align-content-end mt-2 py-0"
             cols="5">
        <v-icon v-if="maxCount!==null" :color="$finColors.lightGrayBlue" class="mr-6">mdi-equal</v-icon>
        <v-text-field :key="'number_'+domRepaintKey"
                      v-model="count"
                      background-color="white"
                      class="mr-4 count-input"
                      :error-messages="[count === 0 ? 'Anzahl > 0' : '']"
                      style="max-width: 100px;"
                      outlined
                      :disabled="!item.latestPrice.price"
                      type="number"/>
      </v-col>
    </v-row>
    <v-row v-if="count > 0">
      <v-col class="py-0 d-flex justify-end align-content-end investment-calc">
        entspricht {{ price | finCurrency }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "FinMobileDistributionSlider",
  props: {
    /** The count of shares */
    value: {
      type: Number,
      default: 0
    },
    /** The maximum number to select */
    maxCount: {
      type: Number,
      default: null
    },
    /** The investment item to display */
    item: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      workingData: 0,
      domRepaintKey: 1,
      sliderValue: this.maxCount ? Math.round(100 / this.maxCount * this.value) : null
    }
  },
  methods: {
    removeItem() {
      /**
       * Event triggered when clicking the recycle bin button.
       *
       * @event remove-item
       * @type {Object} - the object to be removed
       */
      this.$emit('remove-item', this.item)
    },
    changeSlider(val) {
      this.count = Math.round(this.maxCount / 100 * val)
    },
  },
  computed: {
    count: {
      get() {
        return this.value
      },
      set(val) {
        let num = parseInt(val, 10)
        num = isNaN(num) ? 0 : num
        /**
         * Event triggered when changing the count via slider or input field.
         *
         * @event input
         * @type {Number} - the new count
         */
        this.$emit('input', num)
      }
    },
    price() {
      return this.count * this.item.latestPrice.price
    }
  },
  watch: {
    value(val) {
      this.sliderValue = Math.round(100 / this.maxCount * val)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables.scss";

.name {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.price {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.price-value {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.stockinfo {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-cool-grey;
}

.slider-value {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional styling */
  padding-top: 10px;
  margin-right: 10px;
}

.subline {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

::v-deep .v-slider__track-container {
  height: 3px;
}

::v-deep .v-slider__thumb:before {
  -webkit-transform: scale(0.8) !important;
  transform: scale(0.8) !important;
  color: #ffffff;
  box-shadow: $fin-color-shadow;
  border: 1px solid $fin-color-light-sky-blue;
}

::v-deep .v-slider__thumb-container .v-slider__thumb:before {
  opacity: 1;
  color: $fin-color-primary-light;
}

::v-deep .v-slider__thumb-container:hover .v-slider__thumb:before {
  opacity: 1;
  color: $fin-color-primary-light;
}

::v-deep .v-slider__thumb:after {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: $fin-color-primary-dark;
  opacity: 1;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.investment-calc {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

::v-deep .v-input__slot {
  height: 40px !important;
  min-height: 40px !important;
}

.text-gray {
  color: $fin-color-accent-gray
}

.count-input {
  min-width: 55px
}
</style>
